import { Component, OnInit } from '@angular/core';

import { OrganizationAsUserProperty } from './../models/identity/organization-as-user-property.model';
import { AccountsService } from './../services/identity/accounts.service';

@Component({
    templateUrl: './administration-organizations.component.html',
})
export class AdministrationOrganizationsComponent implements OnInit {
    public organization: OrganizationAsUserProperty;

    constructor(public accountsService: AccountsService) {}

    public changeOrganizationIdInService(newId: string) {
        this.accountsService.changeCurrentOrganizationId(newId);
    }

    public ngOnInit() {
        if (this.accountsService.currentUser.organization.isOrganizationManager) {
            this.organization = this.accountsService.currentUser.organization;
            this.changeOrganizationIdInService(this.organization.id);
        }
    }

    public onChangeOrganization(event: any) {
        const newOrganizationId = event;

        if (this.organization && this.organization.id === newOrganizationId) {
            this.changeOrganizationIdInService(newOrganizationId);
        }
    }
}
